import { render, staticRenderFns } from "./PersonalAntecedents.vue?vue&type=template&id=36674b8a&"
import script from "./PersonalAntecedents.vue?vue&type=script&lang=js&"
export * from "./PersonalAntecedents.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAntecedents.vue?vue&type=style&index=0&id=36674b8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports